/**
 * 饼图颜色
 */
function themeColor(type) {
    switch (type) {
        case 'colorGroup':
            return ['#2E59A7', '#3C69A6', '#5976BA', '#88ABDA', '#88C4DA', '#88BCDA', '#6BBBE4'];
        case 'mainColor':
            return '#385C9C';
        case 'mainText':
            return '#303133';
        case 'lineColor':
            return ['#385C9C', '#D77F66'];
        case 'radarContrast':
            return ['#385C9C', '#D77F66', '#5AA450'];
        case 'themeRiver':
            return ['#90DAF4', '#6BBBE4', '#568FC7', '#3E65AB', '#002EA2'];
        case 'pieColor':
            return ['#F1896A', '#F4A78F', '#C54A2C', '#ED6C45'];
        case 'financingValue':
            return [
                '#5AAEF3',
                '#62D9AD',
                '#5B6E96',
                '#a8dffa',
                '#FFDC4C',
                '#FF974C',
                '#E65A56',
                '#6D61E4',
                '#4A6FE2',
                '#6D9AE7',
                '#23C2DB',
            ];
        case 'chainPie':
            return [
                '#5AAEF3',
                '#62D9AD',
                '#5B6E96',
                '#a8dffa',
                '#FFDC4C',
                '#FF974C',
                '#E65A56',
                '#6D61E4',
                '#4A6FE2',
                '#FF99C3',
                '#A6559D',
                '#615EA8',
                '#195688',
                '#3C8E34',
                '#254688',
                '#4994C4',
            ];
        case 'techMainColor':
            return '#9DBEFB';
        case 'techLineColor':
            return ['#9DBEFB', '#D7A577'];
        case 'techLineColors':
            return ['#9DBEFB', '#FFB977', '#4B958D', '#6C77C5', '#CB6252'];
    }
}

export default {
    themeColor: themeColor,
};



//////////////////
// WEBPACK FOOTER
// ./static/theme.js
// module id = iAXy
// module chunks = 5